import { ChangeDetectionStrategy, Component } from "@angular/core";
import { inject } from "@angular/core";
import { saveAs } from "file-saver";
import moment from "moment";
import { IVisionToast } from "../../interfaces/i-vision-toast";
import { ToastService } from "../../services/internal-services/toast.service";
import { INTERNAL_TOAST_TYPES } from "../../model/ToastConstants";
import {
  GoogleAnalyticsConstantsCategory,
  GoogleAnalyticsConstantsEvents,
} from "../../../shared/model/google-analytics-constants";
import { GoogleAnalyticsService } from "../../../shared/services/google-analytics.service";
import { MapCanvasService } from "../../services/internal-services/map-canvas.service";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-screenshot",
  templateUrl: "./screenshot.component.html",
  styleUrls: ["./screenshot.component.scss"],
  standalone: false,
})
export class ScreenshotComponent {
  showToolbar = true;

  private readonly googleAnalyticsService = inject(GoogleAnalyticsService);
  private readonly toastService = inject(ToastService);
  private readonly mapCanvas = inject(MapCanvasService);

  downloadMapCanvas(): void {
    const notification: IVisionToast = {
      id: `screenshot-download-toast`,
      message: `Downloading screenshot...`,
      messageClass: "toast-text",
      titleClass: "toast-text",
      type: INTERNAL_TOAST_TYPES.DOWNLOAD_NOTIFICATIONS,
      timeout: 15000,
      closeButton: false,
      progressBar: true,
    };
    this.toastService.setNotification(notification);

    this.googleAnalyticsService.setGoogleAnalyticsEvent(
      GoogleAnalyticsConstantsEvents.SCREENSHOT,
      GoogleAnalyticsConstantsCategory.LEFT_TOOLBAR,
      true,
    );

    this.mapCanvas
      .captureMapCanvas()
      .then((blob) => {
        this.toastService.removeNotificationsById(`screenshot-download-toast`);
        const date = moment();
        saveAs(blob, `vision_${date.toString()}_capture.png`);
      })
      .catch((err) => {
        console.error("ScreenshotComponent: capture failed", err);
        this.toastService.removeNotificationsById(`screenshot-download-toast`);
      });
  }
}
